import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { IDockingContext, IGseEntity } from '../../../../model/docking';
import { FlightType } from '../../../../model/flights';
import { FlightsService } from '../../flights/flights.service';
import { BasicComponent } from '../../basic-component';

@Component({
    selector: 'app-docking-info',
    templateUrl: './docking-info.component.html',
    styleUrls: ['./docking-info.component.scss']
})
export class DockingInfoComponent extends BasicComponent implements OnChanges {
    @Input() dockingContext: IDockingContext;
    isFlightAvailable: boolean;
    isAcTypeAvailable: boolean;
    isRegNrAvailable: boolean;
    gse: IGseEntity[];

    // Time
    timeString = '';
    timeType = '';

    // Time Comparison
    timeComparisonString1 = '';
    timeComparisonType1 = '';
    timeComparisonString2 = '';
    timeComparisonType2 = '';

    constructor(private readonly flightsService: FlightsService) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes?.dockingContext?.currentValue) {
            this.onContextUpdate(changes.dockingContext.currentValue);
        }
    }

    getFlightTypeIconName(flightType: FlightType): string {
        return this.flightsService.getFlightTypeIconName(flightType);
    }

    private onContextUpdate(dockingContext: IDockingContext): void {
        this.isFlightAvailable = dockingContext.info.flight && dockingContext.info.flight !== '';
        this.isAcTypeAvailable = dockingContext.info.acType && dockingContext.info.acType !== '';
        this.isRegNrAvailable = dockingContext.info.regNr && dockingContext.info.regNr !== '';

        this.timeString = dockingContext.time.timeString;
        this.timeType = dockingContext.time.timeType;

        this.timeComparisonString1 = dockingContext.timeComparison.time1.timeString;
        this.timeComparisonType1 = dockingContext.timeComparison.time1.timeType;
        this.timeComparisonString2 = dockingContext.timeComparison.time2.timeString;
        this.timeComparisonType2 = dockingContext.timeComparison.time2.timeType;
    }
}
